export const arrayContainTargetSubset = (trgt, arr) => Array.isArray(arr) && arr.some(item => trgt.includes(item));
export const arrayContainSubsetOfTarget = (trgt, arr) => Array.isArray(arr) && arr.some(item => item.includes(trgt));
export const arrayHaveRegexMatch = (trgt, regexList) => Array.isArray(regexList) && regexList.some(item => item.test && item.test(trgt));
